"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.locationDirectionsInput = exports.locationDescriptionSimple = exports.locationDescription = exports.locationFromPlace = exports.locationDeserialize = void 0;
const geofire_common_1 = require("geofire-common");
const unwrap_1 = __importDefault(require("../util/unwrap"));
const CoordinatesArray_1 = require("./CoordinatesArray");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
function locationDeserialize(value) {
    const object = (0, deserializeObject_1.default)(value, 'location');
    return {
        coordinates: (0, CoordinatesArray_1.coordinatesArrayDeserialize)(object.coordinates),
        address: (0, unwrap_1.default)(object.address, deserializeString_1.deserializeString),
        geohash: (0, unwrap_1.default)(object.geohash, deserializeString_1.deserializeString),
        googlePlaceId: (0, unwrap_1.default)(object.googlePlaceId, deserializeString_1.deserializeString),
        name: (0, unwrap_1.default)(object.name, deserializeString_1.deserializeString),
        placeId: (0, unwrap_1.default)(object.placeId, deserializeString_1.deserializeString),
        placeName: (0, unwrap_1.default)(object.placeName, deserializeString_1.deserializeString),
        state: (0, unwrap_1.default)(object.state, state => (0, deserializeString_1.deserializeString)(state, 2, 2)),
    };
}
exports.locationDeserialize = locationDeserialize;
function locationFromPlace(place) {
    var _a, _b, _c, _d, _e;
    return {
        coordinates: (0, CoordinatesArray_1.coordinatesArrayDeserialize)([(_a = place.geometry) === null || _a === void 0 ? void 0 : _a.location.lat, (_b = place.geometry) === null || _b === void 0 ? void 0 : _b.location.lng]),
        address: (0, unwrap_1.default)(place.formatted_address, deserializeString_1.deserializeString),
        geohash: (0, unwrap_1.default)((_c = place.geometry) === null || _c === void 0 ? void 0 : _c.location, latLng => (0, geofire_common_1.geohashForLocation)((0, CoordinatesArray_1.coordinatesArrayFromLatLngLiteral)(latLng))),
        googlePlaceId: (0, unwrap_1.default)(place.place_id, deserializeString_1.deserializeString),
        name: (0, unwrap_1.default)(place.name, name => { var _a; return (((_a = place.formatted_address) === null || _a === void 0 ? void 0 : _a.startsWith(name)) ? undefined : place.name); }),
        state: (0, unwrap_1.default)((_e = (_d = place.address_components) === null || _d === void 0 ? void 0 : _d.find(component => component.types.includes('administrative_area_level_1'))) === null || _e === void 0 ? void 0 : _e.short_name, deserializeString_1.deserializeString),
    };
}
exports.locationFromPlace = locationFromPlace;
function locationDescription(location, separator = ', ') {
    return location.name && location.address
        ? [location.name, location.address].join(separator)
        : locationDescriptionSimple(location);
}
exports.locationDescription = locationDescription;
function locationDescriptionSimple(location) {
    var _a, _b;
    return (_b = (_a = location.name) !== null && _a !== void 0 ? _a : location.address) !== null && _b !== void 0 ? _b : 'Pinned location';
}
exports.locationDescriptionSimple = locationDescriptionSimple;
function locationDirectionsInput(location) {
    return location.googlePlaceId
        ? { placeId: location.googlePlaceId }
        : location.address
            ? { address: location.address }
            : location.coordinates;
}
exports.locationDirectionsInput = locationDirectionsInput;
